import { useEffect, useState } from "react";
import { isIOS, isStandalone } from "../push";
import { installPrompt } from "../pwa";

const HINT_DELAY_MS = 1500;

/**
 * Launcher footer: an "Install app" button when the browser offers the install
 * prompt (Chrome on Android/desktop), otherwise short instructions. Hidden once
 * the app runs from the Home Screen.
 */
export default function InstallHint() {
  const [canPrompt, setCanPrompt] = useState(!!installPrompt);
  const [showFallback, setShowFallback] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const sync = () => setCanPrompt(!!installPrompt);
    window.addEventListener("pwa-installable", sync);
    // Give Chrome a moment to fire beforeinstallprompt before showing manual steps.
    const timer = setTimeout(() => setShowFallback(true), HINT_DELAY_MS);
    return () => {
      window.removeEventListener("pwa-installable", sync);
      clearTimeout(timer);
    };
  }, []);

  if (isStandalone()) return null;

  const install = async () => {
    const prompt = installPrompt;
    if (!prompt || busy) return;
    setBusy(true);
    try {
      await prompt.prompt();
      await prompt.userChoice;
    } finally {
      setBusy(false);
      setCanPrompt(!!installPrompt);
    }
  };

  if (canPrompt) {
    return (
      <button
        onClick={install}
        disabled={busy}
        className="pop-in rounded-full bg-white px-6 py-3 text-sm font-bold transition-transform active:scale-95 disabled:opacity-60 border border-line"
      >
        ⬇︎ Install app on this phone
      </button>
    );
  }
  if (!showFallback) return null;

  return (
    <p className="pop-in max-w-xs text-center text-xs font-semibold leading-relaxed text-ink/50">
      {isIOS()
        ? "Install: tap Share in Safari, then “Add to Home Screen”."
        : "Install: open app.soulcake.eu in Chrome (not from a chat or SMS link), tap ⋮, then “Add to Home screen”."}
    </p>
  );
}
